import type {
  HeadingTemplateComponent,
  InternalDropdownOptionsWithHeading,
} from '~/chords/DropdownSingleSelect/types';
import { cn } from '~/lib/cn';

interface DropdownHeadingProps {
  group: InternalDropdownOptionsWithHeading;
  index: number;
  HeadingTemplate?: HeadingTemplateComponent;
}

export function DropdownHeading({
  group,
  index,
  HeadingTemplate,
}: DropdownHeadingProps) {
  if (HeadingTemplate) {
    return <HeadingTemplate group={group} index={index} />;
  }

  return (
    <div
      className={cn(
        'px-md pb-2xs text-body-xs font-semibold uppercase text-emphasis-stronger',
        {
          'pt-sm': !index,
          'pt-xs': index,
        },
      )}
    >
      {group.heading}
    </div>
  );
}

DropdownHeading.displayName = 'DropdownHeading';
